import timer from '../../utils/trainer/timer';
import trainerConfig from '../../config/trainer';
import GameStatsApi from '../../api/games/gameStat';
import gamesConfig from '../../config/games';
import GameExerciseApi from '../../api/games/gameExercise';
import GameHeader from '../../components/trainer/GameHeader.vue';
import Fireworks from '../../components/trainer/games/Fireworks.vue';
import MobileDetect from 'mobile-detect/mobile-detect.js';
import NoPhoneIcon from '../../components/svg/NoPhone.vue';
import GameInfo from '../../components/trainer/games/GameInfo.vue';
import GamePreparationCounter from '../../components/trainer/GamePreparationCounter.vue';
import ResultImage from '../../components/trainer/games/ResultImage.vue';
import ResultButtons from '../../components/trainer/games/ResultButtons.vue';
import RotationIcon from '../../../src/svg/RotationIcon.vue';
import { mapState } from 'vuex';
import _ from 'lodash';

const GAMES_WITH_SOUND = [
    'Puzzle',
    'Couples',
    'CouplesReadingEn',
    'Diada',
    'Chains',
    'ChainsReadingEn',
    'Schulte',
    'AssembleTheNumber',
    'Scanner',
    'Matrix',
    'Navigator',
    'NavigatorBonusGames',
    'Classificator',
    'Search',
    'SoundCouples',
    'FourthOne',
    'DigitCouples',
    'Classifications',
    'Memory',
    'Memorize',
    'SequenceOfNumbers',
    'KeenEye',
    'KeenEyeBonusGames',
    'NumericalNetwork',
    'Associations',
    'WhoIsWho',
    'VocabularyWords',
    'WordDrum',
    'CosmoTour',
    'MentalDrawing',
    'HandsUp',
    'Chameleon',
    'RepeatAfterMe',
    'ChainsBonusGame',
    'Scout',
    'ConnectThePuzzles',
];
const MOBILE_GAMES = [
    'HardSoftConsonants',
    'HardSoftConsonantsSchoolPreparing',
    'TranscriptionInWord',
    'ConnectThePuzzles',
    'Couples',
    'CouplesReadingEn',
    'Diada',
    'Chains',
    'ChainsReadingEn',
    'Anagrams',
    'SoundCouples',
    'FourthOne',
    'CatchWord',
    'CatchWordReadingEn',
    'Matrix',
    'CatchWordOnline',
    'DigitCouples',
    'AnagramsOnline',
    'AssembleTheNumber',
    'NumericalNetwork',
    'SequenceOfNumbers',
    'WhoIsWho',
    'VocabularyWords',
    'SecretsOfCicero',
    'Memo',
    'MemoBonusGames',
    'MemoryX',
    'VocabularyMemo',
    'VocabularyMemoRus',
    'Memorize',
    'KeenEye',
    'KeenEyeBonusGames',
    'Navigator',
    'NavigatorBonusGames',
    'RevivedNumbers',
    'Associations',
    'LettersField',
    'WordsField',
    'WordsFieldReadingEn',
    'LettersFieldOnline',
    'WordsFieldOnline',
    'Synonyms',
    'SynonymsOnline',
    'SynonymsReadingEn',
    'Antonyms',
    'MentalDrawing',
    'HandsUp',
    'Chameleon',
    'RepeatAfterMe',
    'CorrectiveSamples',
    'ChainsBonusGame',
    'Alpari',
    'Scout',
    'TabularMultiplication',
    'VisionField',
    'VisionFieldReadingEn',
    'CosmoTour',
    'Scanner',
    'Shutter',
    'ShutterOnline',
    'ShutterRussianLanguage',
    'Texts',
    'TextsOnline',
    'DivideItRight',
    'ChooseItRight',
    'DivideUnstressedVowels',
    'WordStructure',
    'SentenceParsing',
    'VocabularyWordsRus',
    'WordDrum',
    'TransferSyllables',
    'TransferSyllablesSchoolPreparing',
    'LettersSoundsSyllables',
    'PunctuationMarks',
    'VoicedAndDeafConsonants',
    'PartsOfSpeech',
    'ParsingSentencePartsSpeech',
    'GenericWords',
    'VerbTenses',
    'SortOneMany',
    'Alphabet',
    'Orthograph',
];
const DISABLE_ON_VERTICAL_TABLET = ['Navigator', 'NavigatorBonusGames'];
const DEFAULT_VOLUME = 0.6;
const GAMES_WITH_EXAMPLES = [
    'Couples',
    'Diada',
    'Chains',
    'Scanner',
    'Anagrams',
    'VisionField',
    'VisionFieldReadingEn',
    'Navigator',
    'NavigatorBonusGames',
    'Synonyms',
    'SynonymsReadingEn',
    'Schulte',
    'Antonyms',
    'FourthOne',
    'WhoIsWho',
    'Scout',
];
const GAMES_WITH_RESULT_SOUND = [
    'Anagrams',
    'Synonyms',
    'SynonymsReadingEn',
    'Antonyms',
    'FourthOne',
    'CatchWord',
    'CatchWordReadingEn',
    'CatchWordOnline',
    'SynonymsOnline',
    'AnagramsOnline',
    'Memory',
    'Scout',
];
const GAMES_WITH_METRONOME = ['Shutter', 'Texts', 'ShutterOnline', 'TextsOnline', 'ShutterReadingEn'];
const GAMES_WITH_LOCALE_SOUNDS = ['Navigator', 'NavigatorBonusGames'];
const NAVIGATOR_SOUND_LOCALES = ['bg', 'fr', 'lv', 'ru', 'es'];
const GAMES_ROUTES_WITHOUT_BACKGROUND = ['Shutter', 'ShutterOnline', 'LettersField', 'WordsField', 'CorrectiveSamples', 'WordsFieldReadingEn', 'ShutterReadingEn'];
const EXCEPTIONAL_GAMES = ['Navigator', 'Shulte', 'NavigatorBonusGames', 'Matrix', 'Memorize'];

const TEXTS_GAME_MODE = 'text';

function DEFAULT_DATA() {
    return {
        parameters: null,
        isLoading: true,
        loadedSound: 0,
        gameStarted: false,
        gameFinished: false,
        exercise: null,
        gameStat: null,
        counter: 0,
        beforeGameStartTimeout: null,
        counterTimeout: null,
    };
}

export default {
    props: {
        type: String,
        exerciseId: [String, Number],
        playersNumber: [String, Number],
        playAgain: Boolean,
        gameType: {
            type: String,
            default: 'homework',
        },
    },
    mixins: [timer],
    created() {
        this.$nextTick(this.getWindowDimensions);
    },
    mounted() {
        this.isVerticalScreen = window.innerHeight > window.innerWidth;
        this.isMobile = Boolean(new MobileDetect(window.navigator.userAgent).phone());
        this.isVerticalTablet = Boolean(
            new MobileDetect(window.navigator.userAgent).tablet() && window.innerHeight > window.innerWidth
        );
        window.addEventListener('resize', this.onResize);
        if (this.canFetch && !EXCEPTIONAL_GAMES.includes(this.type)) {
            this.fetchData();
            this.isAlreadyFetched = true;
        }
    },
    updated() {
        if (!this.parameters && this.canFetch && !this.isAlreadyFetched && !EXCEPTIONAL_GAMES.includes(this.type)) {
            this.fetchData();
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
        this.$createjs.Sound.removeAllSounds();
        this.$createjs.Sound.removeAllEventListeners();
    },
    data() {
        return Object.assign(
            {
                soundInstance: null,
                gamesConfig: _.cloneDeep(gamesConfig),
                trainerConfig: _.cloneDeep(trainerConfig),
                isMobile: false,
                isVerticalTablet: false,
                isAlreadyFetched: false,
                isVerticalScreen: false,
                headerKey: true,
                windowWidth: 0,
                windowHeight: 0,
            },
            DEFAULT_DATA()
        );
    },
    watch: {
        isFullScreen(val) {
            if (val && this.isVerticalTablet && !EXCEPTIONAL_GAMES.includes(this.type)) {
                this.fetchData();
            }
        },
        isGameWithoutBackground(val) {
            this.$emit('setBackground', val);
        },
    },
    computed: {
        isMemoryDevelopmentCourse() {
            if (this.parameters?.slug === 'Matrix' ||
                this.parameters?.slug === 'Scanner' ||
                this.gameStat?.game === 'Scanner' ||
                this.gameStat?.game === 'Matrix'
            ) {
                return false;
            }
            if (this.exercise) {
                return this.exercise.courseType === 'memory-development';
            } else {
                return this.parameters.courseType === 'memoryDevelopment';
            }
        },
        isFullScreen() {
            return this.windowWidth >= this.windowHeight;
        },
        ...mapState({
            gameFromLessonConductingTemplate: state => state.trainer.game,
            paramsArray: state => state.trainer.paramsArray,
            user: state => state.auth.user,
        }),
        isOlympiad() {
            return this.gameType === 'olympiad';
        },
        soundObjects() {
            let sounds = [];
            sounds.push(...this.trainerConfig.countdownSound);
            sounds.push(...this.gamesConfig.common.sounds);
            if (GAMES_WITH_METRONOME.includes(this.type)) {
                sounds.push(...this.gamesConfig.metronome.sounds);
            }
            if (GAMES_WITH_SOUND.includes(this.type)) {
                sounds.push(...this.gamesConfig[this.type.toLowerCase()].sounds);
            }
            if (GAMES_WITH_RESULT_SOUND.includes(this.type)) {
                sounds.push(...this.trainerConfig.result);
            }
            if (GAMES_WITH_LOCALE_SOUNDS.includes(this.type)) {
                sounds.push(...this.gamesConfig[this.type.toLowerCase()][this.soundLocale]);
            }
            return sounds;
        },
        soundLocale() {
            if (
                (this.type === 'Navigator' || this.type === 'NavigatorBonusGames') &&
                NAVIGATOR_SOUND_LOCALES.includes(this.user.locale)
            ) {
                return this.user.locale;
            }
            return 'ru';
        },
        canFetch() {
            return (
                (MOBILE_GAMES.includes(this.type) || !this.isMobile) &&
                (!DISABLE_ON_VERTICAL_TABLET.includes(this.type) || !this.isVerticalTablet)
            );
        },
        displayAnswersContainer() {
            return this.isDragging || this.itemsForAnswersBox.length !== 0;
        },
        isGameWithoutBackground() {
            return (
                GAMES_ROUTES_WITHOUT_BACKGROUND.includes(this.type) &&
                this.parameters &&
                this.parameters.mode !== TEXTS_GAME_MODE
            );
        },
        course() {
            if (this.exercise) {
                return this.exercise.courseType;
            } else if (this.parameters) {
                return _.kebabCase(this.parameters.courseType);
            }
        },
        isNotBonusGame() {
            const game = trainerConfig.games.find(
                ({ slug, courseType }) => slug === this.type && courseType === this.course
            );
            return !game.isBonusGame;
        },
    },
    methods: {
        getWindowDimensions() {
            this.windowWidth = document.documentElement.clientWidth;
            this.windowHeight = document.documentElement.clientHeight;
        },
        getExercise() {
            return new Promise((resolve, reject) => {
                if (this.exerciseId) {
                    GameExerciseApi.show(this.exerciseId)
                        .then(data => {
                            let parameters = data.parameters;
                            if (data.slug === 'TextsOnline') {
                                this.parameters = _.isArray(parameters.default)
                                    ? parameters.default.sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate)).at(0)
                                    : parameters.default;
                            } else {
                                this.parameters = parameters.default;
                            }
                            for (let key in parameters) {
                                if (
                                    key !== 'default' &&
                                    key.match(/[\d]*[\d]+/g).some(userId => +userId === this.user.id)
                                ) {
                                    this.parameters = parameters[key];
                                }
                            }
                            this.assignData(data);
                            return this.assignParameters();
                        })
                        .then(stat => {
                            this.assignGameStat(stat);
                            resolve();
                        })
                        .catch(err => {
                            this.showErrorMessage(err);
                            reject();
                        });
                } else if (this.paramsArray?.[0] || this.gameFromLessonConductingTemplate) {
                    const parametersHolder = this.paramsArray?.[0] || this.gameFromLessonConductingTemplate;
                    this.parameters = _.cloneDeep(parametersHolder);
                    if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiad-student')) {
                        this.createStat()
                            .then(stat => {
                                this.assignGameStat(stat);
                                resolve();
                            })
                            .catch(err => {
                                this.showErrorMessage(err);
                                reject();
                            });
                    }
                    resolve();
                } else {
                    this.$router.push({ name: 'dashboard' });
                }
            });
        },
        assignData(data) {
            if (data.homework) {
                this.$store.dispatch('setHomework', data.homework);
                delete data.homework;
            }
            let stat = _.find(data.stats, { userId: this.user.id });
            this.gameStat = stat;
            this.time = data.stats.length > 0 ? stat.executionTime || 0 : 0;
            this.exercise = data;
            if (GAMES_WITH_EXAMPLES.includes(this.exercise.slug)) {
                if (
                    this.exercise.slug === 'Anagrams' ||
                    this.exercise.slug === 'AnagramsOnline' ||
                    this.exercise.slug === 'VisionField' ||
                    this.exercise.slug === 'VisionFieldReadingEn' ||
                    this.exercise.slug === 'Synonyms' ||
                    this.exercise.slug === 'SynonymsReadingEn' ||
                    this.exercise.slug === 'Antonyms'
                ) {
                    this.answers.good = this.exercise.correctAnswers || 0;
                    this.answers.bad = this.exercise.wrongAnswers || 0;
                    return;
                }
                this.chainOfAttempts = (this.gameStat && this.gameStat.chainOfAttempts) || [[]];
                if (this.chainOfAttempts.length) {
                    this.chainOfAttempts = this.chainOfAttempts.map(attempt => Object.values(attempt));
                }
                this.amountOfExamples = this.chainOfAttempts.length ? this.chainOfAttempts.length - 1 : 0;
                if (this.exercise.slug === 'Scanner' && this.gameStat && this.gameStat.parameters.exampleComplication) {
                    this.parameters.numOfUnknowns = this.gameStat.parameters.numOfUnknowns;
                }
            }
        },
        assignParameters() {
            if (!this.gameStat) {
                return this.createStat();
            }
            return this.gameStat;
        },
        createStat() {
            let game = this.exercise ? this.exercise.slug : this.parameters.slug;
            let parameters = this.parameters ? _.cloneDeep(this.parameters) : this.exercise.parameters.default;
            let stat = {
                game,
                parameters,
                course: this.course,
                userId: this.user.id,
                attempts: 0,
                gameExerciseId:
                    this.exercise && this.exercise.sourceType === 'olympiadLevelTrainerStage'
                        ? undefined
                        : this.exerciseId,
            };
            return GameStatsApi.create(stat);
        },
        assignGameStat(stat) {
            stat && (this.gameStat = stat);
        },
        sendStat() {
            if (this.gameStat) {
                this.refreshGameStatBeforeSend();
                this.gameStat.isOlympiadLevelTrainer =
                    this.isOlympiad && this.exercise && this.exercise.sourceType === 'olympiadLevelTrainerStage';
                return GameStatsApi.update(this.gameStat.id, this.gameStat)
                    .then(data => {
                        this.gameStat.id = data.id;
                        if (data.isCompleted) {
                            this.gameFinished = true;
                            this.$emit('finish', data);
                        }
                    })
                    .catch(() => {
                        this.$toasted.error(this.$root.$t('errors.saving_results'));
                    });
            }
        },
        showErrorMessage(err) {
            if (err.data) {
                this.$toasted.error(err.data.message);
                this.$router.push({ name: 'dashboard' });
            }
            err = err.response && err.response.data ? err.response.data : err;
            if (err && (err.status_code === 403 || err.status_code === 404)) {
                this.$router.push({ name: 'dashboard' });
                this.$toasted.error(err.message);
            }
        },
        registerSounds() {
            this.$createjs.Sound.removeAllSounds();
            this.$createjs.Sound.removeAllEventListeners();
            !this.isNotPossibleToPlayWithFlashcardSetting &&
                !this.isMemoryDevelopmentCourse &&
                this.isNotBonusGame &&
                this.$createjs.Sound.addEventListener('fileload', this.soundLoad);
            this.$createjs.Sound.alternateExtensions = ['mp3', 'ogg'];
            this.$createjs.Sound.registerSounds(this.soundObjects);
        },
        soundLoad() {
            this.loadedSound++;
            if (this.loadedSound === this.soundObjects.length) {
                this.isLoading = false;
                this.counter = 0;
                this.runCounter();
            }
        },
        runCounter() {
            this.soundInstance = this.$createjs.Sound.play('beep');
            this.soundInstance.volume = DEFAULT_VOLUME;
            this.counter += 1;
            if (this.counter < 3) {
                clearTimeout(this.counterTimeout);
                this.counterTimeout = setTimeout(this.runCounter, 1000);
            } else {
                this.beforeGameStartTimeout = setTimeout(this.beforeStart, 1000);
            }
        },
        onResize() {
            this.getWindowDimensions();
            this.isVerticalScreen = window.innerHeight > window.innerWidth;
            this.isVerticalTablet = Boolean(
                new MobileDetect(window.navigator.userAgent).tablet() && window.innerHeight > window.innerWidth
            );
        },
        restartGame() {
            this.beforeGameRestart && this.beforeGameRestart();
            Object.assign(this, DEFAULT_DATA());
            clearTimeout(this.counterTimeout);
            this.resetTimer();
            this.fetchData();
        },
    },
    components: {
        ResultImage,
        ResultButtons,
        GameHeader,
        Fireworks,
        NoPhoneIcon,
        GamePreparationCounter,
        GameInfo,
        RotationIcon,
    },
};
